import {ComponentProps} from "../types";

// eslint-disable-next-line max-len
const waitingForPersonalizationOverride = (personalizedData: any) =>
  !personalizedData || !Object.keys(personalizedData).length;

export const overrideWCDContentWithOptimizelyContent = (
  defaultData: Record<string, any> | null | undefined,
  personalizedData: Record<string, any> | null | undefined
) => {
  if (!defaultData?.components) return defaultData;

  const mergedMarketingData = {...defaultData};

  if (waitingForPersonalizationOverride(personalizedData)) {
    // eslint-disable-next-line max-len
    mergedMarketingData.components = defaultData.components.map(
      (component: ComponentProps) =>
        component.experimentRunning
          ? {
              name: "HomeLoadingPlaceholder",
              type: "home",
              data: {},
            }
          : component
    );
  } else {
    mergedMarketingData.components = defaultData.components.map(
      (component: ComponentProps) => {
        if (!personalizedData!.components) return component;
        return (
          personalizedData!.components[component.instanceName] ?? component
        );
      }
    );
  }
  return mergedMarketingData;
};
